import { render, staticRenderFns } from "./general-view.vue?vue&type=template&id=6df3a91c&scoped=true"
import script from "./general-view.vue?vue&type=script&lang=js"
export * from "./general-view.vue?vue&type=script&lang=js"
import style0 from "./general-view.vue?vue&type=style&index=0&id=6df3a91c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df3a91c",
  null
  
)

export default component.exports